import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DialRecordingContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${32 * Screen.widthRatio}px;
`;

export default DialRecordingContainer;
